/**
 * Token store: access token in memory only (XSS-safe), refresh token in sessionStorage for reload.
 * Single source for auth tokens; Http and auth flows use this only.
 */

const REFRESH_TOKEN_KEY = 'refresh_token';

let accessToken: string | null = null;

export const TokenStore = {
  getAccessToken (): string | null {
    return accessToken;
  },

  setAccessToken (token: string): void {
    accessToken = token;
  },

  clearAccessToken (): void {
    accessToken = null;
  },

  getRefreshToken (): string | null {
    try {
      return sessionStorage.getItem(REFRESH_TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setRefreshToken (token: string): void {
    try {
      sessionStorage.setItem(REFRESH_TOKEN_KEY, token);
    } catch {
      // sessionStorage full or unavailable
    }
  },

  clearRefreshToken (): void {
    try {
      sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch {
      // ignore
    }
  },

  clear (): void {
    accessToken = null;
    try {
      sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    } catch {
      // ignore
    }
  }
};
